import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const ACCIDENT = {
  nickname: 'PRODUCTS.ACCIDENT.shortname',
  properties: [
    {
      name: 'wtcAccidentCoverage', key: 'ACCIDENT_COVERAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_COVERAGE.DEATH_AND_DISABILITY',
            value: 'Død og invaliditet' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_COVERAGE.DEATH_AND_DISABILITY_MAX',
            value: 'Død, invaliditet og invaliditet Maks' }
        ]
      }
    },
    {
      name: 'accidentSumInsuredDisability', key: 'ACCIDENT_SUM_INSURED_INCAPACITY', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'wtcAccidentSumInsuredDeath', key: 'ACCIDENT_SUM_INSURED_DEATH', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'clientSsn', key: 'SSN', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.pattern('^[0-9]{11}$')
      ]]
    },
  ],
  lifeInsurance: true,
  icon: 'accident'
};
